

/**
 * @ngdoc function
 * @name app.controller:ModalGisLayerParametersCtrl
 * @description
 * # ModalModalgislayerparametersctrlCtrl
 * Controller of the app
 */
angular.module('app')
	.controller('ModalGisLayerParametersCtrl', /* @ngInject */ function ($scope, $uibModalInstance, colors, layer) {
		$scope.layer = layer;
		$scope.tmp = {};

		if ($scope.layer.type === 'Point') {
			$scope.tmp.scaledSize = $scope.layer.style.icon.scaledSize.width;
		}

		$scope.colors = colors;

		$scope.submit = () => {
			if ($scope.layer.type === 'Point' && $scope.tmp.scaledSize) {
				$scope.layer.style.icon.scaledSize = {
					width:  $scope.tmp.scaledSize,
					height: $scope.tmp.scaledSize,
				};
				$scope.layer.style.icon.size = {
					width:  $scope.tmp.scaledSize,
					height: $scope.tmp.scaledSize,
				};
			}
			$uibModalInstance.close($scope.layer);
		};

		$scope.cancel = () => {
			$uibModalInstance.dismiss();
		};
	});
